
import axios from 'axios'

const loginAxios = axios.create({ baseURL: 'https://edu-demo.amatraedu.com:8081/api/v1/' })
const projectAxios = axios.create({ baseURL: 'https://project-demo.amatraedu.com:8002/api/v1/' })

export { axios, loginAxios, projectAxios }
